import { useProfileAvatarsActionsContext } from '../../contexts'
import styles from './ProfileAvatars.module.scss'
import {
  ProfileAvatarsActions,
  ProfileAvatarsList,
  ProfileAvatarsPopup,
} from './components'

export const ProfileAvatars = () => {
  const { isPopupOpen, setIsPopupOpen } = useProfileAvatarsActionsContext()

  return (
    <>
      <div className={styles.container}>
        <ProfileAvatarsList />

        <ProfileAvatarsPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
        >
          <ProfileAvatarsActions />
        </ProfileAvatarsPopup>
      </div>
    </>
  )
}
